import MdlFamily from '@/models/Warehouse/WhFamily'
import MdlSubFamily from '@/models/Warehouse/WhSubfamily'

//
export default [
    {
        name: 'name',
        props: {
            label: 'Nombre',
        },
        type: 'text-field',
        value: '',
    },
    {
        name: 'alias_name',
        props: {
            label: 'Alias',
        },
        type: 'text-field',
        value: '',
    },
    {
        name: 'internal_code',
        props: {
            label: 'Código Interno',
        },
        type: 'text-field',
        value: '',
    },
    {
        name: 'wh_family_id',
        props: {
            chips: true,
            itemText: 'family',
            itemValue: 'id',
            label: 'Familia',
            model: MdlFamily,
            noObject: true,
        },
        type: 'autocomplete-model',
    },
    {
        name: 'wh_subfamily_id',
        props: {
            chips: true,
            itemText: 'subfamily',
            itemValue: 'id',
            label: 'Sub Familia',
            model: MdlSubFamily,
            noObject: true,
            paramSearch: 'subfamily',
        },
        type: 'autocomplete-model',
    },
]
